import { render, staticRenderFns } from "./PedidoConteudo.vue?vue&type=template&id=631c8f03&scoped=true"
import script from "./PedidoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoConteudo.vue?vue&type=style&index=0&id=631c8f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631c8f03",
  null
  
)

export default component.exports